import { render, staticRenderFns } from "./wholesale.vue?vue&type=template&id=9992bc62&scoped=true&"
import script from "./wholesale.vue?vue&type=script&lang=js&"
export * from "./wholesale.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./wholesale.vue?vue&type=style&index=1&id=9992bc62&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9992bc62",
  null
  
)

export default component.exports